// Generated code for Big.Process.Web.Enums.Gender.
// Edit _Enum.tst to change the generated output.

export enum Gender {
    unknown = 0,
    male = 1,
    female = 2
}
(Gender as any).name = 'Gender';
